import androidx.compose.runtime.CompositionLocalProvider
import com.varabyte.kobweb.core.AppGlobals
import com.varabyte.kobweb.navigation.RoutePrefix
import com.varabyte.kobweb.navigation.Router
import com.varabyte.kobweb.navigation.UpdateHistoryMode
import com.varabyte.kobweb.silk.defer.renderWithDeferred
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.renderComposable

public fun main() {
    RoutePrefix.set("")
    val router = Router()
    com.varabyte.kobweb.core.init.initKobweb(router) { ctx ->
        ctx.router.register("/") { org.abhranilnxt.portfolio.pages.HomePage() }

    }
    router.setLegacyRouteRedirectStrategy(Router.LegacyRouteRedirectStrategy.DISALLOW)
    router.addRouteInterceptor {
        path = path.removeSuffix(".html").removeSuffix(".htm")
    }

    com.varabyte.kobweb.silk.init.additionalSilkInitialization = { ctx ->
        com.varabyte.kobweb.silk.init.initSilkWidgets(ctx)
        com.varabyte.kobweb.silk.init.initSilkWidgetsKobweb(ctx)
        ctx.theme.registerStyle("about-image", org.abhranilnxt.portfolio.styles.AboutImageStyle)
        ctx.theme.registerStyle("about-text", org.abhranilnxt.portfolio.styles.AboutTextStyle)
        ctx.theme.registerStyle("back-to-top-button",
                org.abhranilnxt.portfolio.styles.BackToTopButtonStyle)
        ctx.theme.registerStyle("input", org.abhranilnxt.portfolio.styles.InputStyle)
        ctx.theme.registerStyle("navigation-item",
                org.abhranilnxt.portfolio.styles.NavigationItemStyle)
        ctx.theme.registerStyle("logo", org.abhranilnxt.portfolio.styles.LogoStyle)
        ctx.theme.registerStyle("social-link", org.abhranilnxt.portfolio.styles.SocialLinkStyle)
        ctx.theme.registerStyle("main-button", org.abhranilnxt.portfolio.styles.MainButtonStyle)
        ctx.theme.registerStyle("main-image", org.abhranilnxt.portfolio.styles.MainImageStyle)
        ctx.theme.registerStyle("projects-section",
                org.abhranilnxt.portfolio.styles.ProjectsSectionStyle)
        ctx.theme.registerStyle("projects-arrow-icon",
                org.abhranilnxt.portfolio.styles.ProjectsArrowIconStyle)
        ctx.theme.registerStyle("skills-card", org.abhranilnxt.portfolio.styles.SkillsCardStyle)
        org.abhranilnxt.portfolio.initSiteStyles(ctx)
    }

    // For SEO, we may bake the contents of a page in at build time. However, we will
    // overwrite them the first time we render this page with their composable, dynamic
    // versions. Think of this as poor man's hydration :)
    // See also: https://en.wikipedia.org/wiki/Hydration_(web_development)
    router.navigateTo(window.location.href.removePrefix(window.location.origin),
            UpdateHistoryMode.REPLACE)

    val root = document.getElementById("root")!!
    while (root.firstChild != null) { root.removeChild(root.firstChild!!) }

    AppGlobals.initialize(mapOf("title" to "Portfolio Abhranil"))
    renderComposable(rootElementId = "root") {
        org.abhranilnxt.portfolio.AppEntry {
            router.renderActivePage { renderWithDeferred { it() } }
        }
    }
}
